import { useState } from "react";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { adminApi } from "@/lib/api";

export const OpenRouterTest = () => {
  const [st, setSt] = useState(null);
  const run = async () => {
    setSt({ busy: true });
    try {
      const d = await adminApi.testOpenRouter();
      setSt({ ok: true, msg: `Funziona · modello ${d.model}` });
    } catch (e) {
      setSt({ ok: false, msg: e?.response?.data?.detail || "Chiave non funzionante" });
    }
  };
  return (
    <div className="mt-2 flex items-center gap-3 text-xs">
      <button type="button" data-testid="openrouter-test-btn" onClick={run} disabled={st?.busy}
        className="px-3 py-1.5 border border-[#2B3036] text-[#2B3036] hover:bg-[#2B3036] hover:text-white transition-colors disabled:opacity-50">
        Prova chiave attuale
      </button>
      {st?.busy && <Loader2 className="w-4 h-4 animate-spin text-[#6b7280]" />}
      {st && !st.busy && (
        <span data-testid="openrouter-test-result" className={`inline-flex items-center gap-1 ${st.ok ? "text-[#10b981]" : "text-[#E3242B]"}`}>
          {st.ok ? <CheckCircle2 className="w-4 h-4" /> : <XCircle className="w-4 h-4" />}{st.msg}
        </span>
      )}
    </div>
  );
};
